// 📄 services/slpProveedoresService.ts
//
// "Buscar Proveedores" (SLP, 2026-09-05) — wrapper del callable
// `ariba_BuscarProveedores` (ver functions/callable/aribaBuscarProveedores.js).
// Un solo endpoint fijo (Supplier Data Pagination → vendorDataRequests),
// así que a diferencia de clienteConexionService.ts no hay CRUD acá — solo
// ejecutar la búsqueda con los filtros que arma la pantalla.
import { httpsCallable } from 'firebase/functions';
import { functionsClient } from '../firebase';

export interface FiltrosProveedores {
  smVendorIds: string[];
  erpVendorIds: string[];
  businessUnitList: string[];
  categoryList: string[];
  preferredLevelList: string[];
  qualificationStatusList: string[];
  regionList: string[];
  registrationStatusList: string[];
  withQuestionnaire: boolean;
  withGenericCustomFields: boolean;
  withBankDetail: boolean;
  withTaxDetail: boolean;
  withCompanyCodeDetail: boolean;
  withDisqualifications: boolean;
}

export const FILTROS_PROVEEDORES_VACIOS: FiltrosProveedores = {
  smVendorIds: [],
  erpVendorIds: [],
  businessUnitList: [],
  categoryList: [],
  preferredLevelList: [],
  qualificationStatusList: [],
  regionList: [],
  registrationStatusList: [],
  withQuestionnaire: true,
  withGenericCustomFields: true,
  withBankDetail: true,
  withTaxDetail: true,
  withCompanyCodeDetail: true,
  withDisqualifications: true
};

// La respuesta de Ariba trae los nombres de campo tal cual los devuelve la
// API ("Supplier Name", "SM Vendor ID", ...) — index signature porque el
// set de campos no está formalmente documentado y puede variar; la UI
// accede a los que sabe mostrar y no rompe con el resto.
export interface Proveedor {
  [campo: string]: any;
}

export interface ResultadoBusquedaProveedores {
  ok: boolean;
  status: number;
  proveedores: Proveedor[];
  count: number;
  durationMs: number;
  error: string | null;
}

export const buscarProveedores = async (
  clienteId: string,
  projectId: string,
  apiId: string,
  filtros: FiltrosProveedores
): Promise<ResultadoBusquedaProveedores> => {
  const fn = httpsCallable<
    { clienteId: string; projectId: string; apiId: string; filtros: FiltrosProveedores },
    ResultadoBusquedaProveedores
  >(functionsClient, 'ariba_BuscarProveedores');
  const result = await fn({ clienteId, projectId, apiId, filtros });
  return result.data;
};
